import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { mutationEditorClear } from 'gql/mutations/editor';
import { useQueryLocalEditor } from 'gql/queries/local';
import { useQueryResultsStudyWrongAnswers } from 'gql/queries/results';
import { reportError } from 'lib/tracking';
import { getQuestionVerso } from 'questions';

import StudentErrors from './StudentErrors';

const LIMIT = 5;

const StudentErrorsContainer = (props) => {
  const { t } = useTranslation();
  const {
    data: {
      editor: { status: editorStatus, questionEditing },
    },
  } = useQueryLocalEditor();
  const isVisible = editorStatus === 'student-errors';
  const { isLoading, data, fetchMore } = useQueryResultsStudyWrongAnswers({
    variables: {
      questionId: questionEditing?.id,
      offset: 0,
      limit: LIMIT,
    },
    skip: !isVisible,
  });
  const answers = useMemo(
    () => (isLoading ? [] : data.resultsStudyWrongAnswers),
    [data, isLoading],
  );
  const [currentAnswer, setCurrentAnswer] = useState(0);
  useEffect(() => {
    setCurrentAnswer(0);
    return () => {
      setCurrentAnswer(0);
    };
  }, [questionEditing]);
  const question = useMemo(
    () =>
      !answers[currentAnswer]
        ? questionEditing
        : {
            ...questionEditing,
            ...answers[currentAnswer],
          },
    [answers, currentAnswer, questionEditing],
  );
  const handleAnswerPrevious = useCallback(() => {
    setCurrentAnswer(Math.max(currentAnswer - 1, 0));
  }, [currentAnswer]);
  const handleAnswerNext = useCallback(async () => {
    try {
      if (currentAnswer === answers.length - 2) {
        await fetchMore({
          variables: {
            offset: answers.length,
          },
        });
      }
    } catch (err) {
      reportError('studyAnswers', 'load-more', err);
    } finally {
      setCurrentAnswer(Math.min(currentAnswer + 1, answers.length - 1));
    }
  }, [answers, fetchMore, currentAnswer]);
  const versoComponent = getQuestionVerso(questionEditing?.type);
  return (
    <StudentErrors
      currentAnswer={currentAnswer}
      handleAnswerNext={handleAnswerNext}
      handleAnswerPrevious={handleAnswerPrevious}
      handleClose={mutationEditorClear}
      isVisible={isVisible}
      nAnswers={answers.length}
      question={question}
      versoComponent={versoComponent}
      t={t}
      {...props}
    />
  );
};

export default StudentErrorsContainer;
